<template>
  <div class="collections-wrapper" v-if="data">
    <div
      class="collection-card-wrapper"
      v-for="data in data.results"
      :key="data.key"
      @click="handleCollectionPage(data.id)"
    >
      <div class="title">{{ data.title }}</div>
      <div
        class="card-background"
        :style="{
          backgroundImage: 'url(' + data.cover_photo.urls.small + ')',
        }"
      ></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Search Collections",
    props: ["data"],
    methods: {
      handleCollectionPage(id) {
        this.$router.push(`/collection/${id}`);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .collections-wrapper {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;

    .collection-card-wrapper {
      width: 416px;
      height: 254px;
      background-color: white;
      border-radius: 5px;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
        0 1px 2px 0 rgba(0, 0, 0, 0.06);
      //margin-right: 10px;
      margin-bottom: 10px;
      position: relative;
      overflow: hidden;
      display: flex;

      .card-background {
        position: absolute;
        width: 100%;
        height: 100%;
        background-size: cover;
        filter: blur(1px);
        z-index: 1;
        transition: all 0.2s ease-in;
        &:hover {
          filter: brightness(1.1) blur(1px);
        }
      }
      .title {
        z-index: 10;
        margin: 2rem;
        font-size: 1.2rem;
        text-transform: capitalize;
        color: white;
        font-weight: 600;
        letter-spacing: 1px;
      }
    }
  }
</style>
